module.exports = __webpack_public_path__ + "img/team-15.3464cef3.jpg";